import { withDependencies, named } from '@wix/thunderbolt-ioc'
import type { TpaPageConfig } from '../types'
import type { Experiments, TpaHandlerProvider } from '@wix/thunderbolt-symbols'
import { ExperimentsSymbol, PageFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { name } from '../symbols'
import { isExperimentOpen } from '@wix/thunderbolt-experiments'

export type MessageData = {
	key: string
	scope: 'APP' | 'COMPONENT'
}

export const GetValueHandler = withDependencies(
	[named(PageFeatureConfigSymbol, name), ExperimentsSymbol],
	(tpaPageConfig: TpaPageConfig, experiments: Experiments): TpaHandlerProvider => ({
		getTpaHandlers() {
			const deprecateAppIdExperimentOn = isExperimentOpen(experiments, 'specs.thunderbolt.deprecateAppId')
			return {
				getValue(compId, { key, scope }: MessageData, { originCompId }) {
					const { widgets, appPublicData } = tpaPageConfig
					const { appDefinitionId, applicationId } = widgets[originCompId]
					const appPublicDataKey = deprecateAppIdExperimentOn ? appDefinitionId : applicationId

					const parsedData =
						scope === 'APP' ? appPublicData[appPublicDataKey!] : widgets[originCompId].componentPublicData
					if (!(parsedData && parsedData[key])) {
						return { error: { message: `key ${key} not found in ${scope} scope` } }
					}
					return { [key]: parsedData[key] }
				},
			}
		},
	})
)
